export var App = function (window) {
  "use strict";

  var _config = {
    modules: ["Utilities", "Modals", "Carousels" /*, 'Pinterest' */],
  };

  var _cache = $.extend(
    {},
    {
      $header: $("#page-header"),
      $naviIcon: $("#main-navigation-holder"),
    },
    window.cache
  );

  var _initModules = function () {
    for (var index = 0; index < _config.modules.length; index++) {
      try {
        var module = new window[_config.modules[index]]();

        if (typeof module.init === "function") {
          module.init();
        }

        if (_config.modules[index] === "Utilities") {
          _config.detection = module.detect.all(window.config.notSupportedUserAgents, _cache.$html);
        }
      } catch (e) {
        console.warn("Module is not has no valid structure.", _config.modules[index], e);
      }
    }
  };

  var _checkHash = function (event) {
    var hash = event ? $(event.currentTarget).attr("href") : window.location.hash;

    if (hash !== "#" && hash !== "#/" && $(hash.replace("/", "")).length > 0) {
      // set hash to url
      window.location.hash = hash;

      // scroll to deeplink target
      TweenLite.to(_cache.$window, 0.75, {
        scrollTo: hash.replace("/", ""),
        ease: Expo.easeOut,
        autoKill: true,
      });
    } else {
      window.location.hash = "/";
    }
  };

  var _eventHandlers = {
    onWindowLoad: function (event) {
      // check hash
      _checkHash(null);

      // remove loading class to show page
      window.setTimeout(function () {
        _cache.$body.removeClass("loading");
      }, 1000);
    },

    onWindowScroll: function (event) {
      if (_cache.$window.scrollTop() > 45) {
        _cache.$body.addClass("scrolled");
      } else {
        _cache.$body.removeClass("scrolled");
      }
    },

    onClickDeeplink: function (event) {
      event.preventDefault();
      event.stopPropagation();

      // check hash
      _checkHash(event);
    },

    onClickNavigation: function () {
      if (_cache.$naviIcon.hasClass("active")) {
        setTimeout(
          function () {
            _cache.$naviIcon.removeClass("active");
          },
          150,
          _cache.$naviIcon
        );
      } else {
        _cache.$naviIcon.addClass("active");
      }
    },
  };

  var _collectDeepLinks = function () {
    _cache.$deeplinks = $('[href*="#/"]');
  };

  var _bindEvents = function () {
    _cache.$window.on("load", _eventHandlers.onWindowLoad);
    _cache.$window.on("scroll", _eventHandlers.onWindowScroll).triggerHandler("scroll");
    _cache.$deeplinks !== void 0 && _cache.$deeplinks.on("click", _eventHandlers.onClickDeeplink);

    if (_config.detection.touch) {
      _cache.$naviIcon.on("touchstart", _eventHandlers.onClickNavigation);
    }
  };

  var _init = function () {
    _initModules();
    _collectDeepLinks();
    _bindEvents();
  };

  return {
    init: function () {
      _init();
    },
  };
};
